/**
 * Convert Start and End Dates to range for Export filename
 *
 * @param startDate
 * @param endDate
 * @return {string}
 */
export const convertStartAndEndDatesForFile = (startDate, endDate) => {
    let from = new Date(startDate + 'T00:00:00');
    let to = new Date(endDate + 'T00:00:00');
    let fileStr = '';
    let yy = from.getFullYear();
    let mo = String('00' + parseInt(from.getMonth() + 1, 10)).slice(-2);
    let dd = String('00' + from.getDate()).slice(-2);
    fileStr += yy.toString() + mo.toString() + dd.toString() + '-';
    yy = to.getFullYear();
    mo = String('00' + parseInt(to.getMonth() + 1, 10)).slice(-2);
    dd = String('00' + to.getDate()).slice(-2);
    fileStr += yy.toString() + mo.toString() + dd.toString();
    return fileStr;
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/printFunctions.js